import { createEntityAdapter } from '@reduxjs/toolkit';

const sitesAdapter = createEntityAdapter();

export default sitesAdapter;
